import { ref, reactive, type Ref } from 'vue'

export interface ImagePreviewItem {
  title: string
  created?: number
  prompt?: string
  type: 'pic' | 'three-view' | 'other'
  url: string
}

export interface ImagePreviewProps {
  imageList: ImagePreviewItem[]
  currentIndex: number
  actions?: string[]
  onClose?: () => void
  onNext?: () => void
  onPrev?: () => void
  onDownload?: () => void
}

export interface ImagePreviewState {
  imageList: ImagePreviewItem[]
  currentIndex: number
  onClose?: () => void
  onNext?: () => void
  onPrev?: () => void
  onDownload?: () => void
}

const previewState: Ref<ImagePreviewState | null> = ref(null)

/**
 * 创建图片预览的 hooks
 * @returns 预览控制方法和状态
 */
export const usePreviewImage = () => {
  const showPreview = (props: ImagePreviewProps) => {
    // 使用 reactive 确保响应式
    previewState.value = reactive({
      imageList: props.imageList,
      currentIndex: props.currentIndex,
      onClose: props.onClose,
      onNext: props.onNext,
      onPrev: props.onPrev,
      onDownload: props.onDownload,
    })
  }

  const closePreview = () => {
    previewState.value = null
  }

  return {
    previewState,
    showPreview,
    closePreview,
  }
}
